<template>
  <div>
    <HeaderPublic :showInput="false" @search="searchText" />
    <main>
      <div class="prepaidCard_tool">
        <span @click="init(1)" :class="flag==1?'active':''">个人消费者预付卡应用</span>
        <span @click="init(2)" :class="flag==2?'active':''">预付卡商户应用</span>
      </div>
      <div class="prepaidCard_main">
        <div class="prepaidCard_main_item" v-for="(item,index) in currentData" :key="index">
          <div class="prepaidCard_main_item_goto">
            <span>立即前往</span>
            <span></span>
          </div>
          <div class="prepaidCard_main_item_content">
            <img :src="imgUrl(item.appPhoto)" alt="">
            <div class="prepaidCard_main_itemInfo">
              <span class="prepaidCard_main_label">{{item.appName}}</span>
              <div class="prepaidCard_text">
                <span></span>
                {{item.description}}
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </main>
    <FooterPublic />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HeaderPublic from '@/components/HeaderPublic.vue';
import FooterPublic from '@/components/FooterPublic.vue';
import axios from 'axios';

export default defineComponent({
  name: 'App',
  components: {
   HeaderPublic,
   FooterPublic
  },
  data(){
    return{
      flag:1,
      dataArr:[],
      currentData:[],
    }
  },
  computed:{
    imgUrl(){
      return (v:any) =>{
        if(v){
          return '/api/jfs/file/download/' + v.split(',')[0]
        }else{
          return '/img/prepaidIcon.png'
        }
       
      }
    }
  },
  async created(){
    let res = await axios({
      url:"/api/init/init/init/asset-market/marketapp/token/listWithoutToken",
      method:'post',
      data:{}
    })
    this.dataArr = res.data.data.records
    this.init(1)
  },
  methods:{
    searchText(v:any){
      console.log(v)
    },
    init(v:number){
      this.flag = v
      this.currentData = this.dataArr.filter((e:any)=> v == 1 ? e.appField == 58 : e.appField == 57)
      console.log(this.currentData)
    },
  }
});
</script>

<style lang="scss" scoped>
  main{
    width: 100%;
    .prepaidCard_tool{
      width: 100%;
      height: 68px;
      padding: 0 200px;
      display: flex;
      align-items: center;
      box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
      span{
        cursor: pointer;
        font-size: 18px;
        font-weight: 500;
        color: #888888;
        padding: 11px 12px;
        margin-right: 31px;
      }
      .active{
        background: linear-gradient(22deg, #7A9AE8 0%, #1384E6 100%);
        border-radius: 4px;
        color: #FFFFFF;
      }
    }
    .prepaidCard_main{
      width: 100%;
      padding: 60px 200px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .prepaidCard_main_item{
        margin-bottom: 38px;
        width: 49%;
        height: 220px;
        padding-left: 27px;
        background: url('/img/prepaidCardItem.png') no-repeat;
        background-size: 100% 100%;
        box-shadow: 0px 2px 6px 1px rgba(3,28,99,0.13);
        .prepaidCard_main_item_goto{
          cursor: pointer;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 9px 13px 0 0;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          letter-spacing: 2px;
          span{
            display: inline-block;
            &:last-of-type{
              width: 16px;
              height: 16px;
              background: url('/img/indexIcon5.webp') no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .prepaidCard_main_item_content{
          display: flex;
          margin-right: 20px;
          img{
            width: 160px;
            height: 160px;
          }
          .prepaidCard_main_itemInfo{
            .prepaidCard_main_label{
              padding: 4px 14px;
              font-size: 18px;
              font-weight: 500;
              color: #333333;
              background: rgba(19, 132, 230, 0.06);
              border-radius: 4px;
            }
            .prepaidCard_text{
              margin-top: 10px;
              font-size: 15px;
              font-weight: 400;
              color: #888888;
              padding-left: 15px;
              line-height: 27px;
              span{
                margin-left: -13px;
                display: inline-block;
                width: 8px;
                border-radius: 50%;
                height: 8px;
                background: #308AE6;
              }
            }
          }
          
        }
      }
    }
  }
</style>
